import Request from './request'
import get from 'lodash/get'

const request = new Request()

const gotoLoginSplash = () => {
    const pathname = '/loginsplash'
    if(window.location.pathname === pathname) return
    window.location.assign('/loginsplash')
}

request.addPromiseHandler(prom => prom.then(res => {
    if (Number(get(res, 'status')) === 401) {
        gotoLoginSplash()
    } else {
        const userName = get(res, 'data.userName')
        if (userName) {
            sessionStorage.setItem('userName', userName)
        }
    }
    return res
}, reason => {
    if (Number(get(reason, 'response.status')) === 401) {
        gotoLoginSplash()
    }
    return reason
}))

export const getDepartmentsByUser = () =>
  request.get('/api/users-preferences/departments')
    .then((response) => {
      return response;
    }).catch((error) => {
      console.log("error:" + error.response.data);
      return error.response;
    });


export const getDepartments = () => {
    const getDeptUrl = window.location.origin+'/api/departments'
    console.log("Department Service...",getDeptUrl);
    let  url = `${getDeptUrl}`
    return request.get(url)
        .then(function(response) {
            return response;
        }).catch(function(err) {
            console.log("error:" + err.response.data);
            return err.response;
        });

}

export const getProductService = (pathName) => {
    const getProductUrl = `/api/products/${pathName}`;
    let  url = `${getProductUrl}`
    console.log("URL making call at getProductService",url);
    return request.get(url)
        .then(function(response) {
            console.log("Product Service::",response);
            return response;
        }).catch(function(err) {
            console.log("error:" + err.response.data);
            return err.response;
        });

}


 export const getRequestHeadersService  = () => {
        const getHeaderUrl = '/api/requestheaders'
        let url = `${getHeaderUrl}`
        return request.get(url)
            .then(function (response) {
                console.log("requestheaders", response);
                return response;
            }).catch(function (err) {
                console.log("error:" + err.response.data);
                return err.response;
            });
}

export const getEnvironment  = () => {
    return request.get(window.location.origin+'/api/getenv')
        .then(function(response) {
            return response;
        }).catch(function(err) {
            console.log("error:" + err.response.data);
            return err.response;
        });
}
export const deleteProductService  = (RequestHeaderId,ProductId, DeptNo, VendorNo) =>{
    console.log("Test",window.location.host);
    const getDeleteServiceUrl = window.location.origin+'/api/products/'+RequestHeaderId+'/'+ProductId + '/' + DeptNo + '/' + VendorNo;
    let  url = `${getDeleteServiceUrl}`
    console.log("Delete URL",url);
    return request.delete(url)
        .then(function(response) {
            console.log("requestheaders",response);
            return response;
        }).catch(function(err) {
            console.log("error:" + err.response.data);
            return err.response;
        });
}

export const getVendors = (deptNumber) => {
    const getVendorUrl = `/api/vendors/${deptNumber}`;
    console.log("getVendorUrl Service...",getVendorUrl);
    let  url = `${getVendorUrl}`
    return request.get(url)
        .then(function(response) {
            return response;
        }).catch(function(err) {
            console.log("error:" + err.response.data);
            return err.response;
        });

}
export const getClasses = (deptNumber) => {
    const getClassesUrl = `/api/classes/${deptNumber}`;
    console.log("getClassesUrl Service...",getClassesUrl);
    let  url = `${getClassesUrl}`
    return request.get(url)
        .then(function(response) {
            return response;
        }).catch(function(err) {
            console.log("error:" + err.response.data);
            return err.response;
        });

}
export const getSubclasses = (deptNumber) => {
    const getSubClassesUrl = `/api/subclasses/${deptNumber}`;
    console.log("getSubclasses Service...",getSubClassesUrl);
    let  url = `${getSubClassesUrl}`
    return request.get(url)
        .then(function(response) {
            return response;
            console.log("Subclassrespobse",response);
        }).catch(function(err) {
            console.log("error:" + err.response.data);
            return err.response;
        });

}

export const getNrfcolors = () => {
    const getNrfUrl = `/api/nrfcolors`;
    console.log("getNrfUrl Service...",getNrfUrl);
    let  url = `${getNrfUrl}`
    return request.get(url)
        .then(function(response) {
            return response;
            console.log("getNrfUrl",response);
        }).catch(function(err) {
            console.log("error:" + err.response.data);
            return err.response;
        });

}

export const getPOIdentifiers = () => {
    const getPOIdentifiers = `/api/po-identifiers`;
    console.log("getPOIdentifiers Service...", getPOIdentifiers);
    return request.get(getPOIdentifiers)
      .then(function(response) {
        console.log("getPOIdentifiers", response);
        return response;
      }).catch(function(err) {
        console.log("error:" + err.response.data);
        return err.response;
      });
}

export const putProductService = (data) => {
    const putProductUrl = '/api/products/' + data.RequestHeaderId;
    console.log("putProductUrl Service...", putProductUrl);
    let url = `${putProductUrl}`
    //const processedData = JSON.stringify(data)

    return request.put(url, data)
        .then(function (response) {
            return response;
        })
        .catch(function (err) {
            console.log("error:" + err.response.data);
            return err.response;
        });
}

export const postProductService = (data) => {
    const url = `/api/products`
    return request.post(url, data).catch(function(err) {
        return err;
    });
}

export const createItemProduct = (id, data) => {
    const url = `/api/products/${id}/itempocreate`
    return request.put(url, data);
}


export const putVendorCommitment = (requestHeaderId,data) => {
    const url = `/api/products/${requestHeaderId}/vendorcommit`
    return request.put(url, data, {responseType: 'arraybuffer'});
}
export const getWorkSheet = (workSheet) => {
    const url = '/api/requestheaders?worksheet='+workSheet;
    return request.get(url)
        .then(function(response) {
            return response;
            console.log("Sample Search",response);
        }).catch(function(err) {
            console.log("error:" + err.response.data);
            return err.response;
        });

}
/*
export const geTicketType = (deptNumber,vendorNumber) => {
    const tickettypeUrl = `/api/tickettypes/${deptNumber}/${vendorNumber}`;
    console.log("tickettypeUrl Service...",tickettypeUrl);
    let  url = `${tickettypeUrl}`
    return request.get(url)
        .then(function(response) {
            return response;
        }).catch(function(err) {
            console.log("error:" + err.response.data);
            return err.response;
        });

}*/
export const geTicketType = () => {
  const tickettypeUrl = `/api/tickettypes`;
  let  url = `${tickettypeUrl}`
  console.log("Get Ticket Type URL",url);
  return request.get(url)
    .then(function(response) {
      return response;
      console.log("tickettypeUrl",response);
    }).catch(function(err) {
      console.log("error:" + err.response.data);
      return err.response;
    });

}

export const getPreferredTicketType = (deptNo, vendorNo) => {
    const url = `/api/tickettypes/${deptNo}/${vendorNo}`;
    return request.get(url).catch(err => {
        console.log("error:", err.response.data);
        return err.response;
    })
}

export const getRequestHeadersByIdService  = (headerid, DeptNo, VendorNo) => {
  const url = `/api/requestheaders/${headerid}/${DeptNo}/${VendorNo}`;
  return request.get(url)
    .then(function (response) {
      console.log("requestheadersById", response);
      return response;
    }).catch(function (err) {
      console.log("error:" + err.response.data);
      return err.response;
    });
}

export const getCompareAtSources = () => {
    return request.get(`/api/compareatsources`)
}

export const getSizeGroupsInfoForDepartment = departmentId => {
    if (!departmentId) return Promise.resolve([]);
    const url = `/api/sizegroups/${departmentId}`;
    return request.get(url)
        .then(function (response) {
            return response;
        }).catch(function (err) {
            console.log("error:" + err.response.data);
            return err.response;
        });
};

export const saveView = (viewName, cols, wrkSheetType) => {
    return request.post('/api/views', {
        name: viewName,
        viewState: cols,
        wrkSheetType
    }).catch(function(err) {
        return err.response
    });
};

export const getSellingDiv  = () => {
    const getEnvUrl = 'api/getsellingdiv'
    let  url = `${getEnvUrl}`
    return request.get(url)
        .then(function(response) {
            return response;
        }).catch(function(err) {
            console.log("error:" + err.response.data);
            return err.response;
        });
}

export const postCdpDates = (data) => {
    const url = `/api/getCDPDates`
    return request.post(url, data).catch(function(err) {
        return err;
    });
}

export const updateView = (rowKey, name, cols) => {
    return request.put(`/api/views/${rowKey}`, {
        name,
        viewState: cols
    }).catch(function(err) {
        return err.response
    });
};

export const getSavedViews = (wrkSheetType) => {
    return request.get(`/api/views?wrkSheetType=${wrkSheetType}`)
        .then(response => get(response, "data"))
        .catch(function (err) {
            console.log("error:" + err.response.data);
            return err.response;
        });
};

export const deleteViews = (rowkeys) => {
    if (!_.isArray(rowkeys)) throw "rowkeys has to be an array";
    if (_.isArray(rowkeys) && _.isEmpty(rowkeys)) console.log("rowkeys list empty");

    let keys = _.chain(rowkeys).compact().join(",").defaultTo("").value();
    return request.delete(`/api/views?rowkeys=${keys}`)
        .then(response => get(response, "data"))
        .catch(function (err) {
            console.log("error:" + err.response.data);
            return err.response;
        });
};


// WEBPACK FOOTER //
// ./services/offpriceServices.js